import React, { useState } from 'react';
import { apiPost } from '../utils/api';
import './LoginAdmin.css';

const LoginAdmin = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Effacer l'erreur quand l'utilisateur commence à taper
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username || !formData.password) {
      setError('Veuillez remplir tous les champs');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await apiPost('/admin/auth/login', formData);

      if (response.success) {
        // Stocker le token dans le localStorage
        localStorage.setItem('adminToken', response.token);

        // Appeler le callback de succès
        if (onLoginSuccess) {
          onLoginSuccess(response.user);
        }
      } else {
        setError(response.error || 'Erreur de connexion');
      }
    } catch (err) {
      console.error('Erreur de connexion admin:', err);
      setError(err.message || 'Erreur lors de la connexion');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-page login-admin-container">
      <div className="login-admin-card">
        <div className="login-admin-header">
          <h2>Connexion Administrateur</h2>
          <p>Accès à l'interface d'administration Twitch CLI</p>
        </div>

        <form className="login-admin-form" onSubmit={handleSubmit}>
          <div className="login-admin-field">
            <label htmlFor="username">Nom d'utilisateur</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleInputChange}
              placeholder="Entrez votre nom d'utilisateur"
              disabled={isLoading}
              autoComplete="username"
            />
          </div>

          <div className="login-admin-field">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Entrez votre mot de passe"
              disabled={isLoading}
              autoComplete="current-password"
            />
          </div>

          {error && <div className="login-admin-error">{error}</div>}

          <button
            type="submit"
            className="login-admin-button"
            disabled={isLoading || !formData.username || !formData.password}
          >
            {isLoading ? 'Connexion en cours...' : 'Se connecter'}
          </button>
        </form>

        <div className="login-admin-info">
          <p>
            <strong>Information :</strong> Cette interface est réservée aux
            administrateurs. Assurez-vous d'avoir les droits d'accès appropriés.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginAdmin;











